/**
 * One label, one colour, everywhere the mail layout draws it — so "airport" is
 * the same swatch on every row of the list and beside the subject it sits on,
 * which is what lets an agent find their labelled threads by eye the way a
 * mail client's coloured labels do.
 *
 * Derived from the TITLE rather than the label's stored `color`. Every label
 * the picker or the Gmail sync creates carries the schema's default, and
 * nothing in the console sets another — so reading that column would paint
 * every chip the same teal, the opposite of what a colour per label is for.
 * Case-folded, because the picker treats "VIP" and "vip" as one label.
 *
 * Hue only, from twelve well-separated ones: two labels a few degrees apart
 * read as one colour, which a free 0–359 hash produces all the time.
 * Saturation and lightness come from the `--label-*` tokens in comms.css,
 * which flip with the theme and were picked for the worst hue in each.
 */
const HUES = [0, 25, 45, 90, 145, 170, 195, 215, 240, 265, 290, 330];

export function labelHue(title: string): number {
  const key = title.trim().toLowerCase();
  let hash = 0;
  for (let index = 0; index < key.length; index += 1) {
    hash = (hash * 31 + key.charCodeAt(index)) >>> 0;
  }
  return HUES[hash % HUES.length];
}

export function labelTint(title: string): { background: string; color: string } {
  const hue = labelHue(title);
  return {
    background: `hsl(${hue} var(--label-sat) var(--label-bg-l))`,
    color: `hsl(${hue} var(--label-sat) var(--label-fg-l))`,
  };
}
